import { useEffect, useRef } from 'react'

/**
 * Focus something once the form is editable again.
 *
 * Fields are disabled while a request is in flight, and a disabled field
 * cannot take focus — yet the moment to decide where focus should land is
 * the request's error callback, which runs before the mutation has settled.
 * Asking here records the wish; the effect grants it as soon as `busy` clears,
 * asking `target` for the element only then, so an inline arrow is fine.
 */
export function useFocusWhenEnabled(
  busy: boolean,
  target: () => HTMLElement | null | undefined,
): () => void {
  const wanted = useRef(false)

  useEffect(() => {
    if (busy || !wanted.current) return
    wanted.current = false
    target()?.focus()
  }, [busy, target])

  return () => {
    wanted.current = true
  }
}
